module.exports = __webpack_public_path__ + "img/tandem-kayak.aa3a5366.svg";